export enum UserRolesNames {
  OrganizationAdmin = 'organization_admin',
  AgencyOwner = 'agency_owner',
  ContentOwner = 'content_owner',
  PublisherOwner = 'publisher_owner',
  ContentEditor = 'content_editor',
  PublisherEditor = 'publisher_editor',
  ContentAccounting = 'content_accounting',
  PublisherAccounting = 'publisher_accounting',
  DemandOwner = 'demand_owner',
  DemandAccounting = 'demand_accounting',
  DemandEditor = 'demand_editor'
}

export enum OrganizationTypes {
  Agency = 'agency',
  Content = 'content',
  Publisher = 'publisher',
  Demand = 'demand'
}

export enum ResetPasswordStatus {
  COMPLETED = 'Completed'
}
